<div class="container-fluid d-flex flex-column h-100 px-0">
    <form #customerDetailsForm="ngForm" ngNativeValidate class="row flex-fill h-100 py-2 m-0 ">
        <div class="col-12 d-flex flex-column pb-3 px-0 table-wrapper">
          
          <!-- Personal Details Section -->
          <div class="personal-details-section py-1">
            <div class="row g-0 personal-details-wrapper align-items-center px-2 px-sm-3 py-1 m-0 flex-column d-flex flex-md-row">
              <!-- Avatar -->
              <div class="col-12 col-md-auto avatar-container d-flex justify-content-center align-items-center justify-content-md-start mb-3 mb-md-0">
                <div class="avatar d-flex justify-content-center align-items-start">
                  <!-- Desktop Image -->
                  <img alt="" [src]="customerDetailsModel?.photoUrl ? customerDetailsModel?.photoUrl : './assets/images/svg/default.png'" (error)="$any($event.target).src='assets/images/svg/default.png'" class="d-none d-md-block img-fluid" />
                  
                  <!-- Mobile Image -->
                  <img alt="" [src]="customerDetailsModel?.photoUrl ? customerDetailsModel?.photoUrl : './assets/images/svg/default.png'" (error)="$any($event.target).src='assets/images/svg/default.png'" class="d-block d-md-none" width="50" />
                  
                  <div class="overlay p-0" (click)="disableSection ? fileInput.click() : null">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.355" height="18.224" viewBox="0 0 22.355 18.224">
                      <path id="Path_3304" data-name="Path 3304"
                        d="M-4087.876,869.763a2.431,2.431,0,0,0-2.277-1.307h-2.928c0-.265,0-.509,0-.753a2.176,2.176,0,0,0-2.228-2.263q-3.438-.02-6.876,0a2.179,2.179,0,0,0-2.239,2.276c0,.239,0,.478,0,.745h-.274c-.989,0-1.98-.015-2.968.02a2.425,2.425,0,0,0-2.258,2.352q-.012,5.217,0,10.435a2.45,2.45,0,0,0,2.206,2.362c.181.015.363.024.544.024q8.481,0,16.962,0a2.471,2.471,0,0,0,2.33-1.3,5.54,5.54,0,0,0,.308-.828V870.571A5.511,5.511,0,0,0-4087.876,869.763Zm-10.886,11.738a5.448,5.448,0,0,1-5.444-5.458,5.451,5.451,0,0,1,5.462-5.44,5.466,5.466,0,0,1,5.448,5.457A5.47,5.47,0,0,1-4098.762,881.5Z"
                        transform="translate(4109.931 -865.429)" fill="#fff" />
                    </svg>
                  </div>
                    <input type="file" #fileInput hidden accept="image/*" (change)="onImageSelected($event)" />
                </div>
              </div>
              
              <!-- Form Fields -->
              <div class="col-12 col-md form-fields-container">
                <div class="row g-2 g-md-3">
                  <div class="col-12  col-xl-6 middle">
                    <div class="row g-2 field-row">
                      <div class="col-12 col-sm-6">
                        <app-input [inputName]="'FirstName'" [inputType]="'text'" [inputId]="'FirstName'"
                          [inputValue]="customerDetailsModel.firstname" [inputLabel]="'First Name'" [inputPlaceholder]="'First Name'"
                          (inputValueEmit)="customerDetailsModel.firstname=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.FirstName?.touched || customerDetailsForm?.form?.controls?.FirstName?.dirty) && customerDetailsForm?.form?.controls?.FirstName?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6">
                        <app-input [inputName]="'LastName'" [inputType]="'text'" [inputId]="'LastName'"
                          [inputValue]="customerDetailsModel.lastname" [inputLabel]="'Last Name'" [inputPlaceholder]="'Last Name'"
                          (inputValueEmit)="customerDetailsModel.lastname=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.LastName?.touched || customerDetailsForm?.form?.controls?.LastName?.dirty) && customerDetailsForm?.form?.controls?.LastName?.invalid)}">
                        </app-input>
                      </div>
                    </div>
                    
                    <div class="row g-2 field-row">
                      <div class="col-12 col-sm-6">
                        <app-input [inputName]="'ContactNo'" [onlyNumbers]="true" onlyNumbers  [inputType]="'text'" [inputId]="'ContactNo'"
                          [inputValue]="customerDetailsModel.contactNo" [inputLabel]="'Contact No.'" [inputPlaceholder]="'Contact No'"
                          (inputValueEmit)="customerDetailsModel.contactNo=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.ContactNo?.touched || customerDetailsForm?.form?.controls?.ContactNo?.dirty) && customerDetailsForm?.form?.controls?.ContactNo?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6">
                        <app-input [inputName]="'Email'" [inputType]="'email'" [inputId]="'Email'"
                          [inputValue]="customerDetailsModel.email" [inputLabel]="'Email'" [inputPlaceholder]="'Email'"
                          (inputValueEmit)="customerDetailsModel.email=$event" [isPassPattern]="true"
                          [isRequired]="true" [ngClass]="{'border-red': ((customerDetailsForm?.form?.controls?.Email?.touched || customerDetailsForm?.form?.controls?.Email?.dirty) && customerDetailsForm?.form?.controls?.Email?.invalid)}">
                        </app-input>
                      </div>
                    </div>
                    
                    <div class="row g-2 field-row">
                      <div class="col-12 col-sm-6" *ngIf="!disableSection">
                        <app-input [inputName]="'CRID'" [inputType]="'text'" [inputId]="'CRID'"
                          [inputValue]="customerDetailsModel.crid" [inputLabel]="'CRID'" [inputPlaceholder]="'CRID'"
                          (inputValueEmit)="customerDetailsModel.crid=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.CRID?.touched || customerDetailsForm?.form?.controls?.CRID?.dirty) && customerDetailsForm?.form?.controls?.CRID?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6 d-sm-flex d-none">
                        <app-input [inputName]="'UserName'" [inputType]="'text'" [inputId]="'UserName'"
                          [inputValue]="customerDetailsModel.username" [inputLabel]="'User Name'" [inputPlaceholder]="'User Name'"
                          (inputValueEmit)="customerDetailsModel.username=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.UserName?.touched || customerDetailsForm?.form?.controls?.UserName?.dirty) && customerDetailsForm?.form?.controls?.UserName?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6" *ngIf="disableSection">
                        <app-input [inputName]="'password'" [inputType]="'password'" [inputId]="'password'"
                          [inputValue]="customerDetailsModel.password" [inputLabel]="'Password'" [inputPlaceholder]="'Password'"
                          [isEyeIconShow]="true" (inputValueEmit)="customerDetailsModel.password=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.password?.touched || customerDetailsForm?.form?.controls?.password?.dirty) && customerDetailsForm?.form?.controls?.password?.invalid)}">
                        </app-input>
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-xl-6">
                    <div class="row gx-2 field-row">
                      <div class="col-7 col-sm-6">
                        <app-date-picker [customClass]="'text-black'" [labelName]="'DOB'" [fromDateFromParent]="customerDetailsModel.dob"
                          [clearValue]="true" [inputDate]="customerDetailsModel.dob" (selectedDate)="customerDetailsModel.dob=$event"
                          [isRequired]="true" [disableFutureDate]="true">
                        </app-date-picker>
                      </div>
                      <div class="col-4 checkbox-wrapper d-flex mt-4 justify-content-end  align-items-center">
                        <app-checkbox [dyanamicId]="'Active'" [status]="true" (check)="$event" [checkBoxLabel]="'Active'"
                          [checkBoxClass]="'justify-content-end'">
                        </app-checkbox>
                      </div>
                    </div>
                    
                    <div class="row g-2 field-row">
                      <div class="col-12 col-sm-6" *ngIf="!disableSection">
                        <app-input [inputName]="'IPAddress'" [inputType]="'text'" [inputId]="'IPAddress'"
                          [inputValue]="customerDetailsModel.ipAddress" [inputLabel]="'IP Address'" [inputPlaceholder]="'https://app.jewelsteps.com/'"
                          (inputValueEmit)="customerDetailsModel.ipAddress=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.IPAddress?.touched || customerDetailsForm?.form?.controls?.IPAddress?.dirty) && customerDetailsForm?.form?.controls?.IPAddress?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6" *ngIf="disableSection">
                        <app-input [inputName]="'playStoreLink'" [inputType]="'text'" [inputId]="'playStoreLink'"
                          [inputValue]="customerDetailsModel.playStoreLink" [inputLabel]="'Play Store'"
                          [inputPlaceholder]="'Play Store Link'" (inputValueEmit)="customerDetailsModel.playStoreLink=$event"
                          [isRequired]="!customerDetailsModel.appStoreLink?.trim()"
                          >
                        </app-input>
                      </div>
                       <div class="col-12 d-sm-none">
                        <app-input [inputName]="'UserName'" [inputType]="'text'" [inputId]="'UserName'"
                          [inputValue]="customerDetailsModel.username" [inputLabel]="'User Name'" [inputPlaceholder]="'User Name'"
                          (inputValueEmit)="customerDetailsModel.username=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.UserName?.touched || customerDetailsForm?.form?.controls?.UserName?.dirty) && customerDetailsForm?.form?.controls?.UserName?.invalid)}">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6 d-block d-xl-none" *ngIf="!disableSection">
                        <app-input [inputName]="'password'" [inputType]="'password'" [inputId]="'password'"
                          [inputValue]="customerDetailsModel.password" [inputLabel]="'Password'" [inputPlaceholder]="'Password'" [isEyeIconShow]="true"
                          (inputValueEmit)="customerDetailsModel.password=$event" [isRequired]="true"
                          [ngClass]="{'border-red' : ((customerDetailsForm?.form?.controls?.password?.touched || customerDetailsForm?.form?.controls?.password?.dirty) && customerDetailsForm?.form?.controls?.password?.invalid)}">
                        </app-input>
                      </div>
                     
                    </div>
                    <div class="row field-row d-none d-xl-flex">
                      <div class="col-12 col-sm-6" *ngIf="!disableSection">
                        <app-input [inputName]="'password'" [inputType]="'password'" [inputId]="'password'"
                          [inputValue]="customerDetailsModel.password" [inputLabel]="'Password'" [inputPlaceholder]="'Password'"
                          [isEyeIconShow]="true" (inputValueEmit)="customerDetailsModel.password=$event" [isRequired]="true">
                        </app-input>
                      </div>
                      <div class="col-12 col-sm-6" *ngIf="disableSection">
                        <app-input [inputName]="'appStoreLink'" [inputType]="'text'" [inputId]="'appStoreLink'"
                          [inputValue]="customerDetailsModel.appStoreLink" [inputLabel]="'App Store'"
                          [inputPlaceholder]="'App Store Link'" (inputValueEmit)="customerDetailsModel.appStoreLink=$event"
                          [isRequired]="!customerDetailsModel.playStoreLink?.trim()"
                          >
                        </app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="row p-0 m-0  tab-section flex-fill">
                <div class="col-12 d-flex flex-column">
                  <div class="d-block d-md-none px-2 mb-3">
                    <select class="form-select f-14" [value]="activeTab.toString()" (change)="onMobileTabChange($event)">
                      <option value="1">Business Details</option>
                      <option value="2">Address</option>
                      <option value="3">Bank Details</option>
                      <option value="4" [disabled]="!customerDetailsModel?.currentPlanModel">
                        Current Plan
                      </option>
                      <option value="5">Transaction History</option>
                    </select>
                  
                  </div>
                    <div class="tab-container d-none d-md-flex" id="edit_navtab">
                      <ul ngbNav #nav="ngbNav"
                        [(activeId)]="activeTab"
                        class="nav-tabs">
                        <li [ngbNavItem]="1">
                          <a ngbNavLink>Business Details</a>
                          <ng-template ngbNavContent>
                            <app-business-details [data]="data" [dropdownnData]="getAllDropdown" [businessDetails]="customerDetailsModel"></app-business-details>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="2">
                          <a ngbNavLink>Address</a>
                          <ng-template ngbNavContent>
                          <app-address [dropdownnData]="getAllDropdown" [addressDetails]="customerDetailsModel"></app-address>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="3" *ngIf="!disableSection">
                          <a ngbNavLink>Bank Details</a>
                          <ng-template ngbNavContent>
                           <app-bank-details [dropdownnData]="getAllDropdown" [bankDetails]="customerDetailsModel"></app-bank-details>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="4" *ngIf="!disableSection">
                          <a ngbNavLink>Current Plan</a>
                          <ng-template ngbNavContent  *ngIf="customerDetailsModel?.currentPlanModel">
                            <app-current-plan [currentPlan]="customerDetailsModel"></app-current-plan>
                          </ng-template>
                        </li>
                        <li [ngbNavItem]="5" *ngIf="!disableSection">
                          <a ngbNavLink>Transaction History</a>
                          <ng-template ngbNavContent >
                            <app-transaction-history ></app-transaction-history>
                          </ng-template>
                        </li>
                      </ul>                      
                    </div>
                    <hr class="m-0">
                      
                    <div [ngbNavOutlet]="nav" class="tab-content-wrapper mt-2 flex-fill   overflow-auto"></div>
                   
                  </div>
            </div>      
          </div>
    </form>
</div>